{
    "releaseNotes": {
        "tabName": "Historia wydań",
        "accordianHeading": "Wydanie me@eon V<version>",
        "accordianMyHelpHeading": "Wydanie MyHelp (me@eon) V<version>",
        "accordianMyHelpNewHeading": "Wydanie MyHelp V<version>",
        "whatsNew": "Co nowego",
        "tipsAndTricks": "Porady i wskazówki",
        "faq": "FAQ"
    },
    "ourTeam": {
        "tabName": "Nasz zespół",
        "keyMembers": "Kluczowi członkowie"
    },
    "featureRoadmap": {
        "tabName": "Funkcje i Plan Działań"
    }
}